import { useState } from "react";
import { Fragment } from "react";

import { FormControl, FormControlLabel, Typography, useTheme } from "@mui/material";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import { alpha } from "@mui/material/styles";

import { deepCopyObject } from "../../utils/helpers";
import Checkbox from "../ui/omniCheckbox";
import Dialog from "../ui/omniDialog";
import DialogActions from "../ui/omniDialogActions";
import DialogContent from "../ui/omniDialogContent";
import DialogTitle from "../ui/omniDialogTitle";

const PracticeConversationConfigurationsDialog = props => {
  const {
    open,
    dialogTitle = "Select Conversations",
    okMessage = "OK",
    cancelMessage = "Cancel",
    maxWidth = "xs",
    fullWidth = true,
    associatedConfigurations = [],
    allConfigurations = [],
  } = props;

  const [editedAssociatedConfigurations, setEditedAssociatedConfigurations] = useState(
    associatedConfigurations.slice(),
  );

  const [uniqueBotNames] = useState([
    ...new Set(allConfigurations.map(item => item.omniData.botName)),
  ]);

  const toggleChecked = id => {
    try {
      let newAssociations = editedAssociatedConfigurations.slice();
      if (newAssociations.includes(id)) {
        newAssociations = newAssociations.filter(obj => obj._id !== id);
      } else {
        newAssociations.push(id);
      }
      setEditedAssociatedConfigurations(deepCopyObject(newAssociations));
    } catch (error) {
      console.log(error);
    }
  };

  const onAcceptHandler = () => {
    props.onAccept(editedAssociatedConfigurations);
  };

  const onCloseHandler = () => {
    props.onClose();
  };

  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onCloseHandler}
      disableEscapeKeyDown
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <DialogTitle onClose={onCloseHandler}>{dialogTitle}</DialogTitle>
      <DialogContent>
        <FormControl component="fieldset" sx={{ width: "100%" }}>
          {uniqueBotNames.sort().map((botName, index) => {
            return (
              <Fragment key={"fragment" + index}>
                {index !== 0 && (
                  <Divider
                    sx={{
                      borderRadius: 4,
                      borderColor: alpha(theme.palette.commonground.contrastText, 0.25),
                      height: 1,
                      width: "100%",
                      marginBottom: 0,
                      marginTop: theme.spacing(0.5),
                    }}
                  />
                )}
                <Typography variant="h6" sx={{ userSelect: "none", webkitUserSelect: "none" }}>
                  {botName}
                </Typography>

                {allConfigurations
                  .filter(item => item.omniData.botName === botName)
                  .map((config, index) => {
                    return (
                      <FormControlLabel
                        key={"label" + index}
                        control={
                          <Checkbox
                            checked={editedAssociatedConfigurations.includes(config._id)}
                            onChange={() => toggleChecked(config._id)}
                            name="showAll"
                            color="secondary"
                          />
                        }
                        labelPlacement="end"
                        label={
                          <Typography variant="body1">
                            {config.omniData.conversationName}
                          </Typography>
                        }
                        sx={{
                          marginLeft: theme.spacing(1),
                          marginTop: `-${theme.spacing(1.5)}`,
                          marginBottom: `-${theme.spacing(1)}`,
                        }}
                      />
                    );
                  })}
              </Fragment>
            );
          })}
        </FormControl>
      </DialogContent>

      <DialogActions>
        {cancelMessage && (
          <Button onClick={onCloseHandler} color="secondary" variant="contained">
            {cancelMessage}
          </Button>
        )}
        <Button onClick={onAcceptHandler} color="secondary" variant="contained">
          {okMessage}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PracticeConversationConfigurationsDialog;
